module.exports = __webpack_public_path__ + "img/white-plus-sign.2132b243.svg";